// v2.19.39-sec1 — Interceptor global 401 sur fetch.
// Si une réponse 401 arrive ALORS qu'un token est présent en localStorage,
// on purge la session et redirige vers /login?next=<current>.
// On exclut les routes d'auth elles-mêmes pour éviter une boucle.
import { useEffect } from "react";

const TOKEN_KEY = "civ_user_token";
const PROFILE_KEY = "civ_user_profile";
const AUTH_EVENT = "civ:auth-changed";

const EXCLUDED_PATHS = [
  "/api/auth/request-otp",
  "/api/auth/verify-otp",
  "/api/auth/logout",
];

let patched = false;

export default function AuthInterceptor() {
  useEffect(() => {
    if (patched || typeof window === "undefined") return;
    patched = true;
    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const res = await originalFetch(...args);
      try {
        if (res && res.status === 401) {
          const url = String(args[0] && (args[0].url || args[0])) || "";
          const isExcluded = EXCLUDED_PATHS.some((p) => url.includes(p));
          const hasToken = !!localStorage.getItem(TOKEN_KEY);
          const onLogin = window.location.pathname === "/login";
          if (hasToken && !isExcluded && !onLogin) {
            // Session expirée ou révoquée — purge + redirect
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(PROFILE_KEY);
            window.dispatchEvent(new CustomEvent(AUTH_EVENT, { detail: null }));
            try {
              const mod = await import("sonner");
              mod.toast.error("Session expirée — reconnexion…");
            } catch (_e) {
              /* sonner unavailable, skip toast */
            }
            const next = encodeURIComponent(
              window.location.pathname + window.location.search
            );
            window.location.replace(`/login?next=${next}`);
          }
        }
      } catch (_) {
        /* swallow */
      }
      return res;
    };

    return () => {
      // ne pas restaurer : on veut une interception persistante
    };
  }, []);

  return null;
}
